export const getValidInput = (questionnaire, answers, dimensionsInvolved) => {
  const validInputQuestions = {};

  for (const dimensionIndex of dimensionsInvolved) {
    validInputQuestions[dimensionIndex - 1] = {};
    const questions = questionnaire[dimensionIndex - 1]["questions"] || [];
    const dimensionIsOptional = questionnaire[dimensionIndex - 1]["optional"] || false;

    // Si la dimensión es opcional, se marcan todas las preguntas como válidas y se pasa a la siguiente dimensión
    if (dimensionIsOptional) {
      questions.forEach((_, questionIndex) => {
        validInputQuestions[dimensionIndex - 1][questionIndex] = {
          isValid: true,
        };
      });
      continue;
    }

    questions.forEach((question, questionIndex) => {
      const { question_type, optional } = question;

      let isValid;

      if (optional) {
        isValid = true;
      } else {
        if (answers[dimensionIndex - 1] && answers[dimensionIndex - 1][questionIndex]) {
          const { answer, additionalAnswers } = answers[dimensionIndex - 1][questionIndex]["items"];
          switch (question_type) {
            case "input": {
              isValid = isValidInputsQuestion(answer, question);
              break;
            }
            case "matrix": {
              const { matrixType } = question;
              switch (matrixType) {
                case "selects":
                  isValid = isValidSelectsMatrixQuestion(answer);
                  break;
                case "radios":
                default:
                  isValid = isValidRadiosMatrixQuestion(answer, question);
                  break;
              }
              break;
            }
            case "options": {
              const { selection } = question;
              switch (selection) {
                case "multiple":
                  isValid = isValidMultipleOptionsQuestion(answer, additionalAnswers, question);
                  break;
                case "single":
                default:
                  isValid = isValidSingleOptionsQuestion(answer, additionalAnswers);
                  break;
              }
              break;
            }
            case "textarea":
            case "dropdown":
            case "range":
            default: {
              isValid = true;
              break;
            }
          }
        } else {
          isValid = false;
        }
      }

      validInputQuestions[dimensionIndex - 1][questionIndex] = {
        isValid: isValid,
      };
    });
  }
  return validInputQuestions;
};

const isValidInputsQuestion = (answer, questionData) => {
  const { numberOfFields = 1 } = questionData;

  if (numberOfFields === 1) {
    return true;
  }

  const itemsNo = answer.length;

  for (let i = 0; i < itemsNo; i++) {
    if (answer[i] === "") {
      return false;
    }
  }

  return true;
};

const isValidRadiosMatrixQuestion = (answer, questionData) => {
  const { rows, columns, orientation } = questionData;
  const selectedItems = answer.reduce((acc, item) => (item["value"] !== null ? acc + 1 : acc), 0);

  return orientation === "column"
    ? columns.length === selectedItems
    : rows.length === selectedItems;
};

const isValidSelectsMatrixQuestion = (answer) => {
  for (let i = 0; i < answer.length; i++) {
    if (answer[i]["value"] === "") {
      return false;
    }
  }
  return true;
};

const isValidSingleOptionsQuestion = (answer, additionalAnswers) => {
  if (
    (answer !== "" && !additionalAnswers) ||
    (answer !== "" && additionalAnswers[answer] !== "")
  ) {
    return true;
  } else {
    return false;
  }
};

const isValidMultipleOptionsQuestion = (answer, additionalAnswers, questionData) => {
  const { additionalInputs } = questionData;

  for (const option of answer) {
    if (option["value"]) {
      if (option["name"] === "Otro" && additionalAnswers["Otro"] === "") {
        return false;
      }

      if (additionalInputs) {
        const isAdditionalInput = additionalInputs.find(
          (input) => input["relatedOption"] === option["name"]
        );

        if (isAdditionalInput && !additionalAnswers[option["name"]]) {
          return false;
        }
      }
    }
  }

  return true;
};

export const isValidQuestion = (validInputQuestions, dimensionIndex, questionIndex) => {
  if (!validInputQuestions) {
    // Inicialización de la encuesta, se requiere dejar los inputs verdaderos por defecto
    return true;
  }

  return validInputQuestions[dimensionIndex]?.[questionIndex]?.["isValid"] ?? false;
};

export const isAllInputValid = (validInputQuestions, questionsVisibility) => {
  for (const dimensionIndex in validInputQuestions) {
    for (const questionIndex in validInputQuestions[dimensionIndex]) {
      const isValid = validInputQuestions[dimensionIndex][questionIndex]["isValid"];
      const isVisible = questionsVisibility[dimensionIndex][questionIndex]["visible"];
      if (!isValid && isVisible) {
        return false;
      }
    }
  }
  return true;
};

export const updateFirstInvalidQuestion = (validInput, questionsVisibility) => {
  for (const dimensionIndex in validInput) {
    const questions = validInput[dimensionIndex];
    for (const questionIndex in questions) {
      if (questionsVisibility[dimensionIndex][questionIndex]["visible"]) {
        if (!questions[questionIndex]["isValid"]) {
          return {
            dimensionIndex: parseInt(dimensionIndex),
            questionIndex: parseInt(questionIndex),
          };
        }
      }
    }
  }
  return null;
};
